import axios from "../plugins/parseAxios";

export class ProjectSettingAPI {
  constructor(props) { }
  static updateProjectSetting(payload) {
    return axios.post("functions/updateProjectSetting", payload);
  }
}
